export enum RequestOTPErrors {
  ErrNoBaleAccount = 100,
  ErrTransactionHash = 101,
}

export const RequestOTPErrorMessages = {
  [RequestOTPErrors.ErrNoBaleAccount]: "ErrNoBaleAccount",
  [RequestOTPErrors.ErrTransactionHash]: "خطا در تعداد دفعات ورود",
};

export enum RequestRegisterOTPErrors {
  ErrNoBaleAccount = 100,
  ErrTransactionHash = 101,
}

export const RequestRegisterOTPErrorMessages = {
  [RequestRegisterOTPErrors.ErrNoBaleAccount]: "ErrNoBaleAccount",
  [RequestRegisterOTPErrors.ErrTransactionHash]: "خطا در تعداد دفعات ورود",
};

export enum GetTokenErrors {
  InternalError = 50,
}

export const GetTokenErrorMessages = {
  [GetTokenErrors.InternalError]: "InternalError",
};

export enum RegisterPanelErrors {
  InternalError = 50,
}

export const RegisterPanelErrorMessages = {
  [RegisterPanelErrors.InternalError]: "InternalError",
};

export enum GetPanelsErrors {
  InternalError = 50,
  NoRegisteredPanel = 51,
}

export const GetPanelsErrorMessages = {
  [GetPanelsErrors.InternalError]: "InternalError",
  [GetPanelsErrors.NoRegisteredPanel]: "NoRegisteredPanel",
};

export enum SetAuthDataErrors {
  ErrAuthDataNoLongerEditable = 100,
  ErrNeedToSubmitDoc,
  ErrNecessaryFieldsEmpty,
  ErrAccountIsBanned,
  ErrNeedToWaitForVerification,
}

export const SetAuthDataErrorMessages = {
  [SetAuthDataErrors.ErrAuthDataNoLongerEditable]: "اطلاعات قابل ویرایش نیست.",
  [SetAuthDataErrors.ErrNeedToSubmitDoc]: "لطفا مدارک حقوقی خود را آپلود کنید",
  [SetAuthDataErrors.ErrNecessaryFieldsEmpty]: "همه قسمت ها تکمیل نشده است.",
  [SetAuthDataErrors.ErrAccountIsBanned]: "حساب کاربری شما غیرفعال شده است.",
  [SetAuthDataErrors.ErrNeedToWaitForVerification]:
    "درخواست احرازهویت قبلی در حال بررسی است.",
};

export enum GetCreditErrors {
  InternalError = 50,
}

export const GetCreditErrorMessages = {
  [GetCreditErrors.InternalError]: "InternalError",
};
